var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cursor-pointer primary--text text--underline",domProps:{"textContent":_vm._s(_vm.value)},on:{"click":function($event){return _vm.goTo()}}})}
var staticRenderFns = []

export { render, staticRenderFns }